"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTabbableInputGroup = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ScreenReaderMode = require("../components/UIElements/ScreenReaderMode/ScreenReaderMode");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useTabbableInputGroup = _ref => {
  let {
    groupWrappingElementRef,
    userContext
  } = _ref;
  const cancelEvent = event => {
    event.preventDefault();
    event.returnValue = false;
  };
  const screenReaderMode = (0, _ScreenReaderMode.GetScreenReaderMode)({
    userContext
  });
  (0, _react.useEffect)(() => {
    const groupElement = groupWrappingElementRef.current;
    if (groupElement && !screenReaderMode) {
      groupElement.addEventListener('keydown', event => {
        const {
          target,
          code,
          keyCode,
          shiftKey
        } = event;
        const tabbableInputs = groupElement.querySelectorAll('input[type="radio"]');
        const targetIsFirstInput = target === tabbableInputs[0];
        const targetIsLastInput = target === tabbableInputs[tabbableInputs.length - 1];
        const targetIndex = [...tabbableInputs].indexOf(target);

        // Tab is keyCode 9
        if (code === 9 || keyCode === 9) {
          if (shiftKey) {
            // They are tabbing backwards
            if (!targetIsFirstInput) {
              // Allow a tab on the first element to leave the group
              cancelEvent(event);
              tabbableInputs[targetIndex - 1].focus();
            }
          } else if (!targetIsLastInput) {
            // Allow a tab on the last element to leave the group
            cancelEvent(event);
            tabbableInputs[targetIndex + 1].focus();
          }
        }
      });
    }
  }, [groupWrappingElementRef, screenReaderMode]);
  return {};
};
exports.useTabbableInputGroup = useTabbableInputGroup;
useTabbableInputGroup.propTypes = {
  groupWrappingElementRef: _propTypes.default.element.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  userContext: _propTypes.default.any
};